import React from 'react';
import NnKeyConstants from './NnKeyConstants';
import NnAudioElement from './NnAudioElement';

// A set of audio elements that make the sounds of the keyboard.
class NnSounds extends React.Component {

  // For each octave create an audio element for each of the 12 notes in the cromatic scale.
  render() {
    return (
      NnKeyConstants.octaves.map((octave) =>
        NnKeyConstants.keyNames.map((note) =>
          <NnAudioElement srcfolder={`${window.PUBLIC_URL}/sounds`} octave={octave} note={note} key={octave+note}/>
        )
      )
    )
  }

  static play(keyName, octave='4') {
      let audio = NnAudioElement.getAudioElement(octave, keyName);
      if (audio) {
        audio.play();
      } else {
        console.log('NnSounds.play bad element: ' + octave + keyName);
      }
  }

  static getAudioElement(octave, note) {
      return document.getElementById(this.name + this.octave);
    }
}

export default NnSounds;



// WEBPACK FOOTER //
// ./src/NnSounds.js